import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import api from '../services/api';
import { LangContext } from '../App';

const T = {
  fr: {
    title: 'Mot de passe oublié',
    description:
      'Entrez votre adresse courriel — si un compte est associé, nous vous enverrons un lien de réinitialisation valide pendant 1 heure.',
    email: 'Adresse courriel',
    envoyer: 'Envoyer le lien',
    envoiEnCours: 'Envoi…',
    succes:
      'Si un compte existe pour cette adresse, un courriel de réinitialisation a été envoyé. Vérifiez votre boîte de réception (et vos indésirables).',
    erreur: 'Une erreur est survenue. Veuillez réessayer.',
    retourLogin: '← Retour à la connexion',
  },
  en: {
    title: 'Forgot password',
    description:
      "Enter your email address — if an account exists, we'll send you a reset link valid for 1 hour.",
    email: 'Email address',
    envoyer: 'Send link',
    envoiEnCours: 'Sending…',
    succes:
      'If an account exists for this address, a reset email has been sent. Check your inbox (and spam folder).',
    erreur: 'An error occurred. Please try again.',
    retourLogin: '← Back to sign in',
  },
};

const inputStyle = {
  width: '100%',
  background: 'rgba(255,255,255,0.06)',
  border: '1px solid rgba(255,255,255,0.18)',
  borderRadius: '6px',
  color: 'var(--couleur-texte)',
  padding: '0.75rem 0.9rem',
  fontSize: '0.95rem',
};

const btnStyle = {
  width: '100%',
  padding: '0.85rem',
  background: 'var(--couleur-or)',
  color: '#000',
  border: 'none',
  borderRadius: '6px',
  fontWeight: 600,
  fontSize: '0.95rem',
  cursor: 'pointer',
};

export default function ForgotPassword() {
  const { lang } = useContext(LangContext);
  const t = T[lang] || T.fr;
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setDone(true);
    } catch (_err) {
      // L'endpoint répond toujours 200 — si on tombe ici c'est rate-limit
      // ou erreur réseau. On affiche un message générique.
      setError(t.erreur);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <div
        style={{
          maxWidth: '460px',
          margin: '4rem auto 2rem',
          padding: '2rem',
          background: 'rgba(255,255,255,0.04)',
          borderRadius: '12px',
        }}
      >
        <h1 style={{ marginTop: 0 }}>{t.title}</h1>
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.92rem' }}>{t.description}</p>

        {done ? (
          <div
            style={{
              padding: '1rem',
              background: 'rgba(46, 204, 113, 0.12)',
              border: '1px solid rgba(46, 204, 113, 0.4)',
              borderRadius: '6px',
              color: '#a3e9c5',
              fontSize: '0.92rem',
            }}
          >
            {t.succes}
          </div>
        ) : (
          <form onSubmit={onSubmit} style={{ display: 'grid', gap: '1rem', marginTop: '1.5rem' }}>
            <label>
              <div style={{ marginBottom: '0.35rem', fontSize: '0.86rem' }}>{t.email}</div>
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={inputStyle}
              />
            </label>
            {error && <div style={{ color: '#ff6b6b', fontSize: '0.86rem' }}>{error}</div>}
            <button type="submit" disabled={loading} style={btnStyle}>
              {loading ? t.envoiEnCours : t.envoyer}
            </button>
          </form>
        )}

        <p style={{ marginTop: '1.5rem', textAlign: 'center', fontSize: '0.86rem' }}>
          <Link to="/login" style={{ color: 'var(--couleur-or)', textDecoration: 'none' }}>
            {t.retourLogin}
          </Link>
        </p>
      </div>
    </div>
  );
}
